import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Styled from 'styled';

import views from 'four-nets/icons/svg/icon_views.svg';
import friendship from 'four-nets/icons/svg/icon_friendship.svg';
import UserFriendsDialog from 'four-nets/photoblog/user-blog/author-side/user-friends/user-friends-dialog';
import UserBlogLikersDialog from 'four-nets/photoblog/user-blog/author-side/user-blog-likers/user-blog-likers-dialog';
import { HideForVendor } from 'four-nets/vendor/permissions';

import AuthorSVGIcon from '../author-svg-icon/author-svg-icon';
import { AuthorSocialStatsFragment } from './author-social-stats.graphql';

import defaultStyles from './author-social-stats.scss';

export interface Props extends AuthorSocialStatsFragment {
    styles: typeof defaultStyles;
}

function AuthorSocialStats(props: Props) {
    const { styles, id, photoBlogLikesCount, friendsCount, profile, photoBlog } = props;
    const isVendor = profile && profile.isVendor;

    const [openLikers, setOpenLikers] = useState(false);
    const [openFriends, setOpenFriends] = useState(false);

    return (
        <div className={styles.friends}>
            {photoBlog && photoBlog.id ? (
                <UserBlogLikersDialog id={photoBlog.id} open={openLikers} onClose={() => setOpenLikers(false)} />
            ) : null}
            {id && !Boolean(isVendor) ? (
                <HideForVendor>
                    <UserFriendsDialog id={id} open={openFriends} onClose={() => setOpenFriends(false)} />
                </HideForVendor>
            ) : null}
            <button
                className={styles.friendsItem}
                onClick={() => setOpenLikers(true)}
                disabled={(photoBlogLikesCount !== null && photoBlogLikesCount < 1) || false}
            >
                <AuthorSVGIcon src={views} />
                <FormattedMessage id='SUBSCRIBERS_COUNT' values={{ count: photoBlogLikesCount }} />
            </button>
            {isVendor ? null : (
                <button className={styles.friendsItem} onClick={() => setOpenFriends(true)} disabled={!friendsCount}>
                    <AuthorSVGIcon src={friendship} />
                    <FormattedMessage id='FRINEDS_COUNT' values={{ count: friendsCount }} />
                </button>
            )}
        </div>
    );
}

export default Styled(defaultStyles)(AuthorSocialStats);
